import React from 'react';

import Footer from '../common/footer/Footer';
import Navbar from '../common/navbar/Navbar';
import ProjectsComponent from './ProjectsComponent';


const Projects = () => {
  return (
    <div>
      <Navbar/>
      {/* <Hero2 heading="PROJECTS" text="Some of my recent works"/> */}
      <ProjectsComponent/>
      <Footer/>
    </div>
  )
}

export default Projects;